import React from 'react';
import styled from 'styled-components';

const BlogDetailSection = styled.section`
  padding-top: 8rem;
  background-color: #121212;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ComingSoonContainer = styled.div`
  text-align: center;
  color: #e0e0e0;
  
  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #3b82f6;

    @media (max-width: 480px) {
      font-size: 2rem;
    }

    @media (max-width: 380px) {
      font-size: 1.6rem;
    }
  }
  
  p {
    font-size: 1.2rem;
    color: #a0a0a0;
  }
`;

const BlogDetail = () => {
  return (
    <BlogDetailSection>
      <div className="container">
        <ComingSoonContainer>
          <h1>Coming Soon..</h1>
          <p>This blog post is currently under development.</p>
        </ComingSoonContainer>
      </div>
    </BlogDetailSection>
  );
};

export default BlogDetail;